import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
// import { NgDatepickerModule } from 'ng2-datepicker';
import { FileUploadModule } from 'ng2-file-upload';
import { MatSortModule, MatTableModule, MatInputModule, MatFormFieldModule, MatDatepickerModule, MatNativeDateModule, MatCheckboxModule, MatPaginatorModule } from '@angular/material';
// import { MatSortModule } from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HashLocationStrategy, LocationStrategy, DatePipe } from '@angular/common';
// import { MaterialModule } from '@angular/material';
// import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { CustomFormsModule } from 'ng2-validation';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { TextMaskModule } from 'angular2-text-mask';
import { AuthGuard } from './auth.guard';
import { RetryInterceptor } from './retry.interceptor';

import { CommonService } from './services/common.service';
import { DbService } from './services/db.services';

// Component Starts here
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { MonthPickerComponent } from './monthpicker/month-picker';
import { YearPickerComponent } from './monthpicker/YearPicker';
import { MonthPickerComponent2 } from './monthpicker/month-picker2';
import { YearPickerComponent2 } from './monthpicker/YearPicker2';
import { YearPickerComponent1 } from './monthpicker/YearPicker1';
import { MonthClickComponent } from './monthpicker/MonthClick';
import { QtrMonthComponent } from './monthpicker/QtrMonth';
import { LogoutComponent } from './logout.component';
import { PrintComponent } from './print.component';
import { PrintinnerComponent } from './printinner.component';
import { LoaderComponent } from './loader';

// Services Starts here
import { LoginService } from './login.service';
import { AutosuggestService } from './autosuggest.service';
import { MycurrencyPipe } from './pipe/mycurrency.pipe';
import { ContractorPipe } from './pipe/contractorfilter.pipe';
import { MycurrencyDirective } from './directive/mycurrency.directive';
import { NgInit } from './directive/ngInit.directive';
import { OnlyNumber } from './directive/onlynumber.directive';
import { MonthPickerDirective } from './directive/monthPicker.directive';
import { MonthpickerDirective } from './monthpicker.directive';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { FocusDirective } from './focus.directive';
import { SearchPipe } from './search.pipe';
import { startsWithPipe } from './customstart.pipes';
import { InventoryManagerComponent } from './inventory-manager/inventory-manager.component';
import { AddInventoryManagerComponent } from './add-inventory-manager/add-inventory-manager.component';
import { MatButtonModule, MatSelectModule, MatIconModule } from '@angular/material';
import { EmpDetailsComponent } from './emp-details/emp-details.component';
import { SelectportComponent } from './selectport/selectport.component';
import { ServiceOfferedComponent } from './service-offered/service-offered.component';
import { AddServiceOfferedComponent } from './add-service-offered/add-service-offered.component';
import { ServiceListComponent } from './service-list/service-list.component';
import { AddServiceListComponent } from './add-service-list/add-service-list.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { CustomerSchedularComponent } from './customer-schedular/customer-schedular.component';
import { CustomerSchedularListComponent } from './customer-schedular-list/customer-schedular-list.component';
import { ServiceCategoryComponent } from './service-category/service-category.component';
import { AddServiceCategoryComponent } from './add-service-category/add-service-category.component';
import { CustomerReportComponent } from './customer-report/customer-report.component';
import { EmployeeReportComponent } from './employee-report/employee-report.component';

import { PackageCategoryComponent } from './package-category/package-category.component';
import { AddPackageCategoryComponent } from './add-package-category/add-package-category.component';
import { PackageComponent } from './package/package.component';
import { AddPackageComponent } from './add-package/add-package.component';
import { BillingComponent } from './billing/billing.component';
import { DiscountOffersComponent } from './discount-offers/discount-offers.component';
import { AddDiscountOffersComponent } from './add-discount-offers/add-discount-offers.component';
import { AddCouponComponent } from './add-coupon/add-coupon.component';
import { CouponComponent } from './coupon/coupon.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { InvoiceReportComponent } from './invoice-report/invoice-report.component';
import { CurrencyWithoutSymbolPipe } from './currency-without-symbol.pipe';
import { PrintBillingComponent } from './print-billing/print-billing.component';
import { PrintPreviewComponent } from './print-preview/print-preview.component';
import { AddProductComponent } from './add-product/add-product.component';
import { SellProductComponent } from './sell-product/sell-product.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AddUsablesComponent } from './add-usables/add-usables.component';
import { ProductsInServiceComponent } from './products-in-service/products-in-service.component';
import { ServicesInProductComponent } from './services-in-product/services-in-product.component';
import { ProductReportComponent } from './product-report/product-report.component';
import { FooterService } from './footer.service';
import { ProductUsageReportComponent } from './product-usage-report/product-usage-report.component';
import { DynamicReportComponent } from './dynamic-report/dynamic-report.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { TransactionalsmsComponent } from './transactionalsms/transactionalsms.component';
import { PromotionalsmsComponent } from './promotionalsms/promotionalsms.component';
import { TransactionalSmsReportComponent } from './transactional-sms-report/transactional-sms-report.component';
import { PromotionalsmsReportComponent } from './promotionalsms-report/promotionalsms-report.component';
import { MaxDisComponent } from './max-dis/max-dis.component';
import { AddMaxDisComponent } from './add-max-dis/add-max-dis.component';
import { MembershipComponent } from './membership/membership.component';
import { MembershipSetupComponent } from './membership-setup/membership-setup.component';
import { VeiwMemBillComponent } from './veiw-mem-bill/veiw-mem-bill.component';
import { MemReportComponent } from './mem-report/mem-report.component';
import { OfferReportComponent } from './offer-report/offer-report.component';
import { PrintCusBillComponent } from './print-cus-bill/print-cus-bill.component';
import { WhatsAppTemplateComponent } from './whats-app-template/whats-app-template.component';
import { AddWhatsAppTemplateComponent } from './add-whats-app-template/add-whats-app-template.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { DocumentsComponent } from './documents/documents.component';
import { IncentiveSetupComponent } from './incentive-setup/incentive-setup.component';
import { PartnershipSetupComponent } from './partnership-setup/partnership-setup.component';
import { PartnershipSetupGridComponent } from './partnership-setup-grid/partnership-setup-grid.component';
import { PartnershipReportComponent } from './partnership-report/partnership-report.component';
import { CustomerPartnershipReportComponent } from './customer-partnership-report/customer-partnership-report.component';
import { IncentiveSetupGridComponent } from './incentive-setup-grid/incentive-setup-grid.component';
import { AccessControlPanelComponent } from './access-control-panel/access-control-panel.component';
import { UploadComponent } from './upload/upload.component';
import { DailyAttendanceComponent } from './daily-attendance/daily-attendance.component';
import { AttendanceDashboardComponent } from './attendance-dashboard/attendance-dashboard.component';
import { WeeklyRosterComponent } from './weekly-roster/weekly-roster.component';
import { WeekOffManagementComponent } from './week-off-management/week-off-management.component';
import { MonthlyClaendarComponent } from './monthly-claendar/monthly-claendar.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { ChartsComponent } from './charts/charts.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ComboComponent } from './combo/combo.component';
import { ComboCategoryComponent } from './combo-category/combo-category.component';
import { AddComboCategoryComponent } from './add-combo-category/add-combo-category.component';
import { AddComboComponent } from './add-combo/add-combo.component';
import { PackageReceiptComponent } from './package-receipt/package-receipt.component';
import { AddSalonComponent } from './add-salon/add-salon.component';
import { ManageSalonsComponent } from './manage-salons/manage-salons.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { MetaTemplateApprovalComponent } from './meta-template-approval/meta-template-approval.component';
import { PackageReportComponent } from './package-report/package-report.component';
import { BulkWhatsappComponent } from './bulk-whatsapp/bulk-whatsapp.component';
import { WhatsappChatComponent } from './whatsapp-chat/whatsapp-chat.component';
import { CreditsHistoryComponent } from './credits-history/credits-history.component';
import { ChatNotificationWidgetComponent } from './chat-notification-widget/chat-notification-widget.component';
import { ChatNotificationService } from './services/chat-notification.service';
import { WhatsAppChatService } from './services/whatsapp-chat.service';
import { WhatsAppSentReportComponent } from './whatsapp-sent-report/whatsapp-sent-report.component';
import { WhatsAppReportService } from './services/whatsapp-report.service';
import { WhatsappCampaignReportComponent } from './whatsapp-campaign-report/whatsapp-campaign-report.component';




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MycurrencyPipe,
    SearchPipe,
    startsWithPipe,
    ContractorPipe,
    MycurrencyDirective,
    MonthPickerDirective,
    MonthPickerComponent,
    YearPickerComponent,
    MonthPickerComponent2,
    YearPickerComponent2,
    YearPickerComponent1,
    NgInit,
    OnlyNumber,
    MonthpickerDirective,
    MonthClickComponent,
    QtrMonthComponent,
    LogoutComponent,
    PrintComponent,
    PrintinnerComponent,
    ResetpasswordComponent,
    LoaderComponent,
    FocusDirective,
    InventoryManagerComponent,
    AddInventoryManagerComponent,
    EmpDetailsComponent,
    SelectportComponent,
    ServiceOfferedComponent,
    AddServiceOfferedComponent,
    ServiceListComponent,
    AddServiceListComponent,
    CustomerDetailsComponent,
    CustomerSchedularComponent,
    CustomerSchedularListComponent,
    ServiceCategoryComponent,
    AddServiceCategoryComponent,
    CustomerReportComponent,
    EmployeeReportComponent,

    PackageCategoryComponent,
    AddPackageCategoryComponent,
    PackageComponent,
    AddPackageComponent,
    BillingComponent,
    DiscountOffersComponent,
    AddDiscountOffersComponent,
    AddCouponComponent,
    CouponComponent,
    CheckoutComponent,
    InvoiceReportComponent,
    CurrencyWithoutSymbolPipe,
    PrintBillingComponent,
    PrintPreviewComponent,
    AddProductComponent,
    SellProductComponent,
    AddUsablesComponent,
    ProductsInServiceComponent,
    ServicesInProductComponent,
    ProductReportComponent,
    ProductUsageReportComponent,
    DynamicReportComponent,
    TransactionalsmsComponent,
    PromotionalsmsComponent,
    TransactionalSmsReportComponent,
    PromotionalsmsReportComponent,
    MaxDisComponent,
    AddMaxDisComponent,
    MembershipComponent,
    MembershipSetupComponent,
    VeiwMemBillComponent,
    MemReportComponent,
    OfferReportComponent,
    PrintCusBillComponent,
    WhatsAppTemplateComponent,
    AddWhatsAppTemplateComponent,
    MetaTemplateApprovalComponent,
    ChangepasswordComponent,
    DocumentsComponent,
    IncentiveSetupComponent,
    PartnershipSetupComponent,
    PartnershipSetupGridComponent,
    PartnershipReportComponent,
    CustomerPartnershipReportComponent,
    IncentiveSetupGridComponent,
    AccessControlPanelComponent,
    UploadComponent,
    DailyAttendanceComponent,
    AttendanceDashboardComponent,
    WeeklyRosterComponent,
    WeekOffManagementComponent,
    MonthlyClaendarComponent,
    ChartsComponent,
    ComboComponent,
    ComboCategoryComponent,
    AddComboCategoryComponent,
    AddComboComponent,
    PackageReceiptComponent,
    AddSalonComponent,
    ManageSalonsComponent,
    PrivacyPolicyComponent,
    PackageReportComponent,
    BulkWhatsappComponent,
    WhatsappChatComponent,
    ChatNotificationWidgetComponent,
    CreditsHistoryComponent,
    WhatsAppSentReportComponent,
    WhatsappCampaignReportComponent

  ],
  imports: [
    BrowserModule,
    MatSelectModule,
    MatAutocompleteModule,
    // NgDatepickerModule,
    FormsModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    AppRoutingModule,
    HttpClientModule,
    FlashMessagesModule,
    BrowserAnimationsModule,
    CustomFormsModule,
    NgbModule.forRoot(),
    NgxMyDatePickerModule.forRoot(),
    FileUploadModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    TextMaskModule,
    MatCheckboxModule,
    MatSortModule,
    MatTableModule,
    NgxPaginationModule,
    NgxEchartsModule
    // FileSelectDirective
    // Ng2AutoCompleteModule
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, AuthGuard, FooterService, LoginService, DbService, CommonService, DatePipe, AutosuggestService, MonthClickComponent, QtrMonthComponent, LoaderComponent, ChatNotificationService, WhatsAppChatService, WhatsAppReportService, { provide: LocationStrategy, useClass: HashLocationStrategy }, { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts